const parties = [
    { value: '1', name: 'African National Congress', abbreviation: 'ANC' },
    { value: '2', name: 'African Transformation Movement', abbreviation: 'ATM' },
    { value: '3', name: 'Democratic Alliance', abbreviation: 'DA' },
    { value: '4', name: 'Economic Freedom Fighters', abbreviation: 'EFF' },
    { value: '5', name: 'Freedom Front Plus', abbreviation: 'FF Plus' },
    { value: '6', name: 'United Democratic Movement', abbreviation: 'UDM' },
    { value: '7', name: 'African Independent Congress', abbreviation: 'AIC' },
    { value: '8', name: 'Congress Of The People', abbreviation: 'COPE' },
  ];
  export default parties;